import theme from '~/assets/theme';

const styles = {
  container: {
    display: 'flex',
    gap: 16,
    width: '100%',
    paddingRight: 45,
  },
  item: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    backgroundColor: theme.palette.gray[10],
    borderRadius: 8,
    border: `1px solid ${theme.palette.gray[20]}`,
    padding: '10px 12px',
    fontSize: 14,
    color: '#333',
    fontWeight: 500,
  },
  dot: {
    width: 20,
    height: 20,
    borderRadius: '50%',
  },
  operation: {
    backgroundColor: theme.palette.tag.operation,
  },
  operationStop: {
    backgroundColor: theme.palette.tag.operationStop,
  },
  maintenance: {
    backgroundColor: theme.palette.tag.maintenance,
  },
  empty: {
    backgroundColor: theme.palette.tag.empty,
  },
};

export default styles;
